import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService, GET, Adapter, POST, Body } from "@royalty/httpclient";

@Injectable()
export class SystemConfigurationService extends HttpService {
	/**
	 * Restautant
	 */
	@GET("configuration/getRestaurant")
	@Adapter(null, { isAdmin: true })
	getConfigRestautant(): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdateRestaurant")
	@Adapter(null, {
		isAdmin: true,
		messageUpdateSuccess: "Update Successfully"
	})
	createOrUpdateRestaurant(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Terminal
	 */
	@GET("configuration/getTerminal")
	@Adapter(null, { isAdmin: true })
	getConfigTerminal(): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdateTerminal")
	@Adapter(null, {
		isAdmin: true,
		messageUpdateSuccess: "Update Successfully"
	})
	createOrUpdateTerminal(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Order Configuration
	 */
	@GET("configuration/getOrderConfig")
	@Adapter(null, { isAdmin: true })
	getConfigOrderConfig(): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdateOrderConfig")
	@Adapter(null, {
		isAdmin: true,
		messageUpdateSuccess: "Update Successfully"
	})
	createOrUpdateOrderConfig(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Card Configuration
	 */
	@GET("configuration/getCardConfig")
	@Adapter(null, { isAdmin: true })
	getConfigCardConfig(): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdateCardConfig")
	@Adapter(null, {
		isAdmin: true,
		messageUpdateSuccess: "Update Successfully"
	})
	createOrUpdateCardConfig(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Tax Configuration
	 */
	@GET("configuration/getTaxConfig")
	@Adapter(null, { isAdmin: true })
	getConfigTaxConfig(): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdateTaxConfig")
	@Adapter(null, {
		isAdmin: true,
		messageUpdateSuccess: "Update Successfully"
	})
	createOrUpdateTaxConfig(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Printer
	 */
	@GET("configuration/getinstalledprinters")
	@Adapter(null, { isAdmin: true })
	getinstalledprinters(): Observable<any> {
		return null;
	}

	@GET("configuration/getPrinters")
	@Adapter(null, { isAdmin: true })
	getPrinters(): Observable<any> {
		return null;
	}

	@GET("configuration/getKitchenPrinters")
	@Adapter(null, { isAdmin: true })
	getKitchenPrinters(): Observable<any> {
		return null;
	}

	@GET("configuration/getPrinterGroups")
	@Adapter(null, { isAdmin: true })
	getPrinterGroups(): Observable<any> {
		return null;
	}

	@POST("configuration/getVirtualPrinters")
	@Adapter(null, { isAdmin: true })
	getVirtualPrinters(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/createKitchenPrinter")
	@Adapter(null, { isAdmin: true })
	createKitchenPrinter(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/createOrUpdatePrinters")
	@Adapter(null, { isAdmin: true })
	createOrUpdatePrinters(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/updateKitchenPrinter")
	@Adapter(null, { isAdmin: true })
	updateKitchenPrinter(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/createVirtualPrinter")
	@Adapter(null, { isAdmin: true })
	createVirtualPrinter(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/deleteKitchenPrinters")
	@Adapter(null, { isAdmin: true })
	deleteKitchenPrinters(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/deletePrinterGroups")
	@Adapter(null, { isAdmin: true })
	deletePrinterGroups(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/createPrinterGroup")
	@Adapter(null, { isAdmin: true })
	createPrinterGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/updatePrinterGroup")
	@Adapter(null, { isAdmin: true })
	updatePrinterGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST("configuration/getPrinterGroupById")
	@Adapter(null, { isAdmin: true })
	getPrinterGroupById(@Body data: string): Observable<any> {
		return null;
	}
}
